import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Uncaught error in app tree:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#080a10',
            color: '#edeff7',
            fontFamily: 'sans-serif',
            textAlign: 'center',
          }}
        >
          <div>
            <p style={{ marginBottom: 8, fontWeight: 600 }}>Something went wrong.</p>
            <p style={{ color: '#8b93a8', fontSize: '0.9rem' }}>
              Please refresh the page. Check the browser console for details.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}